import { render } from "./CardNews.vue?vue&type=template&id=6b1a218a"
import script from "./CardNews.vue?vue&type=script&lang=js"
export * from "./CardNews.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__